import { CommonModule, formatDate } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { ActivatedRoute } from '@angular/router';
import { TourChannel, TourStatus } from '../../enums/tour-statuses.enum';
import { MessageService } from 'primeng/api';
import { TourService } from '../followups/tour.service';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from '../../core/shared/shared.module';
import { TourTokenService } from './tour-token.service';
import { CalendarModule } from 'primeng/calendar';
import moment from 'moment';
import { PropertyService } from '../properties/service/property.service';
import { TimezoneDateRangeUtil } from '../../core/shared/utils/timezone-date-range.util';
import { take } from 'rxjs';
@Component({
  selector: 'app-properties',
  standalone: true,
  imports: [TableModule,
    CommonModule,
    DropdownModule,
    InputTextModule,
    ButtonModule,
    FormsModule,
    DialogModule,
    ToastModule,
    SharedModule,
    CalendarModule
  ],
  templateUrl: './manage-tours.component.html',
  styleUrls: ['./manage-tours.component.scss'],
  providers: [MessageService]
})
export class ManageTourComponent {
  tours: any[] = [];
  loading = true;
  error = '';
  timeZone: string = '';
  searchTerm = '';
  cancelTourDialog: boolean = false;
  selectedTour: any = null;
  isConfirmLoading: boolean = false;
  rescheduleTourDialog: boolean = false;
  dateTimeDialog: boolean = false;
  selectedDate: Date | null = null;
  selectedTime: string | null = null;
  step: number = 1;
  minDate = new Date();
  availableTimes: string[] = [];
  isTimeLoading: boolean = false;
  sorting: any = {
    field: '',
    order: 1
  };
  totalRecords: number = 0;
  rowsPerPage: number = 10;
  currentPage: number = 0;
  propertyTimezone: string = 'UTC';
  visitorName: string = '';
  visitorEmail: string = '';
  customerPhone: string = '';
  userInfo: any = null;
  maxDate!: Date;
  isAutoCancelLink: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private tourTokenService: TourTokenService,
    private messageService: MessageService,
    private tourService: TourService,
    private propertyService: PropertyService
  ) { }

  ngOnInit() {
    this.loadTours();
    this.selectedDate = new Date();
    // this.propertyService.getUserInfo().subscribe(user => {
    //   this.userInfo = user;
    //   const { minDate, maxDate } = TimezoneDateRangeUtil.todayToNextDays(
    //     this.userInfo.property.timezone,
    //     29
    //   );
    //   this.maxDate = maxDate;
    // });
    //this.goToTimeSelection();
  }

  getProperty(propertyId: string): void {
    if (!propertyId) return;

    this.propertyService.getPropertyById(propertyId).pipe(take(1)).subscribe((property) => {

      this.userInfo = property;

      const { maxDate } = TimezoneDateRangeUtil.todayToNextDays(property?.timezone, 29);

      this.maxDate = maxDate;
    });
  }
  
  loadTours(event?: any): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) return;
    this.isAutoCancelLink = this.route.snapshot.queryParamMap.get('source') === 'auto-cancel';

    this.loading = true;

    const page = event ? event.first / event.rows : 0;
    const limit = event ? event.rows : this.rowsPerPage;
    const sortField = event?.sortField || 'createdAt';
    const sortOrder = event?.sortOrder || -1;

    const listingRequest$ = this.isAutoCancelLink
      ? this.tourTokenService.validateAutoCancelToken(token)
      : this.tourTokenService.validateToken(token, {
      page,
      limit,
      sortField,
      sortOrder,
      search: this.searchTerm,
    });

    listingRequest$.subscribe({
      next: (res) => {
        console.log('res', res)
        this.visitorName = res.visitor.customerName;
        this.visitorEmail = res.visitor.customerEmail;
        this.customerPhone = res.visitor.customerPhone;
        this.tours = res.tours;
        this.totalRecords = res.total ?? res.tours?.length ?? 0;
        this.loading = false;

        const propertyId = res.visitor.propertyId || res.tours?.[0]?.property_id?._id;
        this.getProperty(propertyId);
      },
      error: () => {
        this.error = 'Link expired or invalid.';
        this.loading = false;
      }
    });
  }

  // ✅ Simple search filter
  get filteredTours() {
    if (!this.searchTerm.trim()) return this.tours;
    const term = this.searchTerm.toLowerCase();
    return this.tours.filter(tour =>
      (tour.property_name?.toLowerCase().includes(term)) ||
      (tour.tour_id?.toString().includes(term)) ||
      (tour.customer_email?.toLowerCase().includes(term))
    );
  }

  closeDialogue(): void {
    this.cancelTourDialog = false;
    this.rescheduleTourDialog = false;
    this.selectedTour = null;
    this.dateTimeDialog = false;
    this.isConfirmLoading = false;
    this.selectedDate = null;
    this.selectedTime = null;
  }

  confirmCancelTour(followup: any): void {
    this.cancelTourDialog = true;
    this.isConfirmLoading = false;
    this.selectedTour = followup;
  }

  cancelTour(): void {
    if (!this.selectedTour) return;
    this.isConfirmLoading = true;
    const payload = {
      performerName: this.visitorName,
      performerEmail: this.visitorEmail,
      channel: TourChannel.LINK
    };
    this.tourService.cancelTour(this.selectedTour._id, payload).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Tour is ${TourStatus.CANCELLED} successfully`,
        });
        this.selectedTour.tourStatus = TourStatus.CANCELLED;

        // Reload tours
        this.loadTours();

        setTimeout(() => {
          this.cancelTourDialog = false;
        }, 500);
      },
      error: (error: any) => {
        const errorMessage = error?.error?.message || 'Failed to cancel tour!';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage
        });
        setTimeout(() => {
          this.cancelTourDialog = false;
        }, 500);
      },
      complete: () => {
        this.isConfirmLoading = false;
      },
    });
  }

  tourStatus(followUp: any): { text: string; class: string } {
    const status = followUp?.status;
    const tourStatus = followUp?.tourStatus;

    // if status is Active or Pending, prefer that
    if ((status === TourStatus.ACTIVE && tourStatus == TourStatus.IN_PROGRESS) || (status === TourStatus.PENDING && tourStatus !== TourStatus.CANCELLED)) {
      return this.formatStatus(status);
    }

    // otherwise, use tourStatus (completed, cancelled, etc.)
    const appendText = (status === TourStatus.PENDING && tourStatus == TourStatus.CANCELLED) ? 'Auto ' : '';
    return this.formatStatus(tourStatus, appendText);
  }

  formatStatus(value: string, appendText: string = ''): { text: string; class: string } {
    if (!value) return { text: '', class: '' };
    const formatted = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    return {
        text: appendText ? appendText + formatted : formatted,
        class: formatted
    };
  }

  confirmReschedulelTour(followup: any): void {
    this.rescheduleTourDialog = true;
    this.isConfirmLoading = false;
    this.selectedTour = followup;
  }

  rescheduleTourConfirm() {
    this.rescheduleTourDialog = false;
    this.step = 1;
    // this.selectedDate = null;
    this.selectedTime = null;
    this.dateTimeDialog = true;
    this.isConfirmLoading = false;
  }

  onDateSelect(date: Date) {
    // Just to be safe, check if the selected date is valid
    if (date >= this.minDate) {
      this.goToTimeSelection();
    }
  }

  goToTimeSelection() {
    if (!this.selectedDate) {
      return;
    }

    this.step = 2;
    this.isTimeLoading = true;
    const scheduleDate = formatDate(this.selectedDate, 'MM/dd/yyyy', 'en-US');

    // Convert selected date to weekday
    const weekday = this.selectedDate.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

    let propId = this.selectedTour.property_id?._id;
    this.propertyTimezone = this.selectedTour.property_id?.timezone;
    this.tourService.getPropertyTimeSlot(propId, weekday, scheduleDate).subscribe({
      next: (res: any) => {
        console.log('response', res)
        this.isTimeLoading = false;
        this.propertyTimezone = res.timeZone;
        const utcSlots = res.slots || [];
        this.availableTimes = utcSlots.map((utcTime: string) => {
          return this.convertUtcToPropertyTimezone(utcTime, this.propertyTimezone);
        });
        if (!this.availableTimes.length) {
          let message = 'No time slots available on this date.';
          if(res?.blackoutDate){
            message = 'Tours are not available on this date.';
          }
          this.messageService.add({
            severity: 'warn',
            summary: 'No Slots',
            detail: message
          });
        }
      },
      error: () => {
        this.isTimeLoading = false;
        this.availableTimes = [];
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load available time slots'
        });
      }
    });
  }

  convertUtcToPropertyTimezone(utcTime: string, targetTimezone: string): string {
    // utcTime should be something like "14:00" or "2025-11-10T14:00:00Z"
    const utcMoment = moment.utc(utcTime, ['HH:mm', moment.ISO_8601]);
    const localMoment = utcMoment.clone(); //.tz(targetTimezone);
    return localMoment.format('hh:mm A'); // e.g. 02:00 PM
  }

  rescheduleTour(): void {
    if (!this.selectedDate) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a date.' });
      return;
    }

    if (!this.selectedTime) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a time.' });
      return;
    }

    if (!this.selectedTour) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'No tour selected.' });
      return;
    }

    this.isConfirmLoading = true;

    // if (tourPayload.time instanceof Date) {
    //   const planDate = formatDate(tourPayload.date, 'yyyy-MM-dd', 'en-US');
    //   tourPayload.planned_date = planDate + ' ' + (tourPayload.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    //   tourPayload.time = (tourPayload.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    // }
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeZoneLong = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'long',
    }).formatToParts(new Date()).find((part) => part.type === 'timeZoneName')?.value;

    const payload = {
      rescheduleDate: formatDate(this.selectedDate, 'MM/dd/yyyy', 'en-US'),
      rescheduleTime: this.selectedTime,
      client_time_zone: timeZone,
      client_formatted_time_zone: timeZoneLong,
      propertyTimezone: this.propertyTimezone,
      performerName: this.visitorName,
      performerEmail: this.visitorEmail,
      channel: TourChannel.LINK,
      source: this.isAutoCancelLink ? 'auto-cancel' : 'standard',
    };
    console.log('payload', payload)
    this.tourService.rescheduleTour(this.selectedTour._id, payload).subscribe({
      next: (res) => {
        this.isConfirmLoading = false;
        this.dateTimeDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Tour is ${TourStatus.RESCHEDULED} successfully`,
        });

        // Reload tours
        this.loadTours();
      },
      error: (error: any) => {
        const errorMessage = error?.error?.message || 'Failed to reschedule tour!';
        this.isConfirmLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage
        });
      }
    });
  }
}